import type { OptionsMap } from '@openx/types/options.ts';
import type { PackageListItem } from '@openx/types/package.ts';
import { getPackageListTargetingValues } from '@openx/utils/lib/packages/getPackageListTargetingValues.ts';

type MapPackagesParams = {
  packagesList: PackageListItem[];
  deviceTypeOptions: OptionsMap;
  distributionChannelOptions: OptionsMap;
  adPlacementOptions: OptionsMap;
  isOa?: boolean;
};

const mapOptionIdsToNames = (value: string | null | undefined, options: OptionsMap): string => {
  if (!value) {
    return '';
  }

  return value
    .split(',')
    .map(id => options[id.trim()]?.name)
    .filter((name): name is string => Boolean(name))
    .join(', ');
};

export const mapPackages = ({
  packagesList,
  deviceTypeOptions,
  distributionChannelOptions,
  adPlacementOptions,
  isOa = false,
}: MapPackagesParams): PackageListItem[] =>
  packagesList.map(packageItem => {
    const source = isOa
      ? {
          ...packageItem,
          ...getPackageListTargetingValues(packageItem.targeting),
        }
      : packageItem;

    return {
      ...source,
      ad_placement: mapOptionIdsToNames(source?.ad_placement, adPlacementOptions),
      device_type: mapOptionIdsToNames(source?.device_type, deviceTypeOptions),
      distribution_channel: mapOptionIdsToNames(source?.distribution_channel, distributionChannelOptions),
    };
  });
